<template>
  <div class="page page-home">

    <Swiper
      :showNav="false"
      :parameters="{
        autoplay: { delay: 5000 },
        pagination: {
          clickable: true,
          el: '.swiper-pagination'
        }
      }"
    >
      <div class="swiper-slide">
        <div class="hero">
          <div class="hero-img">
            <picture>
              <source srcset="../assets/img/hero/saska.jpg" media="(min-width: 576px)">
              <img srcset="../assets/img/hero/saska-m.jpg" alt="">
            </picture>
          </div>
          <div class="hero-content top sm-bottom">
            <h1 class="page-title">Claim Your Power</h1>
          </div>
        </div>
      </div>
      <div class="swiper-slide">
        <div class="hero">
          <div class="hero-img">
            <picture>
              <source srcset="../assets/img/hero/chad.jpg" media="(min-width: 576px)">
              <img srcset="../assets/img/hero/chad-m.jpg" alt="">
            </picture>
          </div>
          <div class="hero-content bottom">
            <h1 class="page-title">No Excuses</h1>
          </div>
        </div>
      </div>
    </Swiper>

    <div class="home-content">
      <!-- 3 Pillars -->
      <div class="three-pillars-section">

        <div class="container">
          <h2>
            <span>3 Pillars</span>
            <span class="of"> of </span>
            <span>Success</span>
          </h2>
          <ThreePillars />
        </div>

        <div class="curves-bottom" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1920 125.7" style="enable-background:new 0 0 1920 125.7;" xml:space="preserve">
            <path class="fill-body-bg" d="M1920,0v44.2c0,0-451,63.8-960,6.3S0,125.7,0,125.7L0,0L1920,0z"></path>
          </svg>
        </div>

      </div>

      <!-- Services -->
      <div class="services-section">
        <div class="container">

          <h2>Services</h2>

          <div class="row services-cards">
            <div class="col-md-6 col-xl-3">
              <div class="card">
                <img class="card-img-top" src="../assets/img/service/personal-training.jpg" alt="">
                <div class="card-body">
                  <h3 class="card-title">Personal Training</h3>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-3">
              <div class="card">
                <img class="card-img-top" src="../assets/img/service/beach-built-hiit-classes.jpg" alt="">
                <div class="card-body">
                  <h3 class="card-title">Beach-Built HIIT Classes</h3>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-3">
              <div class="card">
                <img class="card-img-top" src="../assets/img/service/nutrition-classes.jpg" alt="">
                <div class="card-body">
                  <h3 class="card-title">Nutrition Classes</h3>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-3">
              <div class="card">
                <img class="card-img-top" src="../assets/img/service/accountability-program.jpg" alt="">
                <div class="card-body">
                  <h3 class="card-title">Accountability Program</h3>
                </div>
              </div>
            </div>
          </div>

          <router-link :to="{ name: 'services' }" class="btn btn-light">
            view details
          </router-link>

        </div>

        <div class="wave-bottom">
          <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="140px" viewBox="20 -20 300 100" xml:space="preserve">
            <path class="fill-body-bg" opacity="0.4" d="M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729 c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z"></path>
            <path class="fill-body-bg" opacity="0.4" d="M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729 c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z"></path>
            <path class="fill-body-bg" opacity="0" d="M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716 H42.401L43.415,98.342z"></path>
            <path class="fill-body-bg" d="M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428 c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z"></path>
          </svg>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import ThreePillars from '@/components/ThreePillars'
import Swiper from '@/components/Swiper'

export default {
  name: 'home',
  components: {
    ThreePillars,
    Swiper
  },

  created () {
    this.$emit('ready')
  }
}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.home-content {

  .three-pillars-section {
    position: relative;
    padding: 30px 0;
    background: $body-bg;

    h2 {
      color: $black;
      font-size: rem(40);
      text-align: center;
      line-height: 1;
      margin: 0 0 30px 0;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;

      .of {
        color: $white;
        font-size: .95rem;
        //font-weight: bold;
        vertical-align: middle;
        padding: rem(5) rem(8) rem(3) rem(8);
        margin: 13px 8px 0 8px;
        position: relative;
        background: $black;
        border-radius: 90px;

        &:before {
          content: '';
          width: 20px;
          height: 12px;
          border-radius: 7px 7px 10px 10px;
          border: 3px solid $black;
          background: transparent;
          position: absolute;
          top: -9px;
          left: 50%;
          right: 0;
          transform: translate3d(-50%, 0, 0);
        }
      }
    }

    .curves-top,
    .curves-bottom,
    .slant-left-bottom {
      position: absolute;
      right: 0;
      left: 0;
      z-index: 1;
    }

    .curves-top {
      bottom: 100%;
      margin-bottom: -2px;
    }

    .curves-bottom {
      top: 100%;
      margin-top: -2px;

      // Fix iOS/iphone issue
      overflow: hidden;
      svg {
        margin: 0 -5px;
      }
    }

    .slant-left-bottom {
      bottom: 0;
    }

    @include media-breakpoint-up(sm) {
      h2 {
        display: block;
        .of {
          padding: rem(3);
          margin: 0 8px;
        }
      }
    }

    @include media-breakpoint-up(lg) {
      h2 {
        // font-size: $h1-font-size;
      }
    }
  }

  .services-section {
    padding: 8rem 0 10rem 0;
  }

}
</style>
